import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import Panel from './panel'
import FlashAlert from '../../../../components/flash-alert'
import GenerealInfo from './general-info'
import Members from './members'
import Other from './other'
import Buttons from './buttons'
import { ajaxGet, postForm } from '../../../../ajax'

export default function NewTeam({league, locationName, onClose, onCreate}) {
  const { register, control, reset, handleSubmit, setValue, getValues, clearErrors, formState: { errors } } = useForm({})

  const [team, setTeam] = useState()
  const [newMember, setNewMember] = useState(null)
  const [members, setMembers] = useState([])
  const [allowNext, setAllowNext] = useState(false)
  const [alert, setAlert] = useState(null)
  const [fileLoaded, setFileLoaded] = useState(false)
  const [loading, setLoading] = useState(true)

  const photoUrl = getValues('photo_url')
  const [step, setStep] = useState('General Info')
  const isGeneralStep = step == 'General Info'
  const isMembersStep = step == 'Team Member'
  const isOtherStep = step == 'Other'
  
  useEffect(() => {
    loadDefaults()
  }, [])

  useEffect(() => {
    if (team) reset(team)
  }, [team])

  useEffect(() => {
    if (errors.name) clearErrors('name')
  }, [step])

  const loadDefaults = () => {
    ajaxGet(`/admins/leagues/${league.id}/teams/new.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => { 
      setTeam(json.team)
      setLoading(false)
    })
  }
  
  const prepareMembersData = (formData) => {
    members.forEach((member, i) => {
      formData.append(`team[members_attributes][${i}][player_id]`, member.player_id)
      formData.append(`team[members_attributes][${i}][league_id]`, league.id)
      formData.append(`team[members_attributes][${i}][captain]`, member.captain)
    })
  }

  const prepareFormData = (data) => {
    let formData = new FormData()
    formData.append('team[name]', data.name.trim())
    formData.append('team[notes]', data.notes.trim())
    if (data.photo_url) formData.append('team[photo_url]', data.photo_url)
    formData.append('team[color]', data.color ? data.color.map(v => v.label).join(', ') : '')
    formData.append('team[about]', data.about)
    prepareMembersData(formData)
    return formData
  }

  const onSubmit = (data) => {
    setLoading(true)

    let formData = prepareFormData(data)

    postForm(`/admins/leagues/${league.id}/teams.json`, formData)
    .then(response => { return response.json() })
    .then((json) => {
      setLoading(false)
      if (json.alert)
        setAlert(json.alert)
      else {
        onCreate(json.team)
      }
    })
  }

  return <Modal container={document.body} backdrop='static' show={true} onHide={onClose} dialogClassName='new-team-modal'>
    <Modal.Header closeButton>
      <Modal.Title>Create Team</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      { loading && <div className='animated-spinner'></div> }
      { team &&
        <form className={'new-team-form' + (loading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <Panel steps={['General Info', 'Team Member', 'Other']} currentStep={step} />
          { alert && <FlashAlert text={alert.text} type={alert.type} onHide={() => setAlert(null)} />}
          <GenerealInfo 
            hidden={!isGeneralStep}
            locationName={locationName}
            register={register}
            errors={errors}
            setValue={setValue}
            photoUrl={photoUrl}
            onFileLoaded={setFileLoaded}
            onNameChanged={value => setAllowNext(!!value.trim())}
          />
          <Members
            hidden={!isMembersStep}
            league={league}
            member={newMember}
            members={members}
            setMember={setNewMember}
            setMembers={setMembers}
            onAlert={message => setAlert({ text: message, type: 'alert' })}
          />
          <Other hidden={!isOtherStep} register={register} control={control} setValue={setValue} />
          <Buttons 
            next={!isOtherStep}
            create={isOtherStep}
            back={!isGeneralStep}
            allowNext={allowNext}
            step={step}
            setStep={setStep}
          />
        </form>
      }
    </Modal.Body>
  </Modal>
}
